import Cookies from "js-cookie";
export default {
  _getUserLevel(_level) {
    // console.log('_level:' + _level);
    let level = _level;
    if (!level) {
      // console.log('!level:' + level);
      level = Cookies.get("userLevel");
    }
    if (level <= 5) { return ""; }
    if (level == 6) { return "VIP"; }
    if (level == 100) { return "SVIP"; }
    if (level == 150) { return "专业版"; }
    if (level == 170) { return "旗舰版"; }
    if (level == 200) { return "企业版"; }

    return "";
  }, getWaterMarkTip(level) {

    let userLevel = this._getUserLevel(level);
    if (userLevel == "") {
      return `升级为5118付费会员,即可去除水印     <a id="wordfrequency-upgrade" href='https://account.5118.com/member?m=vip&p=wordcloudgenerate&b=up&r=0' target='_blank' style='color:white; text-decoration: underline;
}'>   我要升级</a>`;
    } else {
      return `亲爱的5118${
        userLevel
        }用户,我们已为您自动去除水印`;
    }
  }

}